import React from 'react'
import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
// import CardActionButton from './CardActionButton'
import PaymentMethod from '../../common/PaymentMethod'
import TitleCard from '../common/TitleCard'
import CardWrapper from './CardWrapper'

export default function CardPaymentDetails({ team, loading, onBtnClick }) {
  if (loading) {
    return (
      <CardWrapper>
        <TitleCard>Payment Methods</TitleCard>
        <Skeleton height={80} />
      </CardWrapper>
    )
  }
  return (
    <CardWrapper>
      {/* will allow card management later on when card can be changed (fast follow) */}
      {/* <CardActionButton name="Manage" onClick={onBtnClick} /> */}
      <TitleCard>Payment Methods</TitleCard>
      <Box mt={2}>
        <PaymentMethod
          isTeamContext
          teamId={team?.id}
          paymentMethodId={team?.plan?.primaryMethod}
          primaryMethodId={team?.plan?.primaryMethod}
          onError={() => {}}
          readOnly
          condensed
          flat
        />
      </Box>
    </CardWrapper>
  )
}
